import * as React from 'react';
import styled from 'styled-components';
import { Button } from '../button/Button';

const ConfirmBoxStyle = styled.div`
  background: ${({ theme }) => theme.colors.burgundy};
  color: ${({ theme }) => theme.colors.primary};
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  //width: 400px;
  width: 95%;
  max-width: 400px;
  height: 220px;
  z-index:10;
`;

const ConfirmButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 2em;
`;

const TextWrapper = styled.div`
  margin-top: 3em;
  h3 {
    margin-top: -19px;
  }
`;

export const ConfirmBox: React.FC<{
  className?: string;
  close: () => void;
  handleDelete: any;
}> = (props) => {
  const preventPropagation = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <ConfirmBoxStyle className={props.className} onClick={preventPropagation}>
      <TextWrapper>
        <h3>Bekreft sletting</h3>
        <p>Vil du virkelig slette?</p>
      </TextWrapper>
      <ConfirmButtonWrapper>
        <Button type="primary" colorTheme="gold" onClick={props.close}>
          Avbryt
        </Button>
        <Button type="primary" colorTheme="gold" onClick={props.handleDelete}>
          Slett
        </Button>
      </ConfirmButtonWrapper>
    </ConfirmBoxStyle>
  );
};
